/**
 * Formatters for the SPA. German locale, conservative defaults — undefined /
 * null values render as an em-dash so the table never shows "NaN" or "null".
 */

const EUR = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

const EUR_PER_M2 = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

const M2 = new Intl.NumberFormat("de-DE", {
  maximumFractionDigits: 1,
});

const SCORE = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

const RTF = new Intl.RelativeTimeFormat("de-DE", { numeric: "auto" });

export const EM_DASH = "—";

export function formatEur(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return EM_DASH;
  return EUR.format(value);
}

export function formatEurPerM2(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return EM_DASH;
  return `${EUR_PER_M2.format(value)}/m²`;
}

export function formatM2(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return EM_DASH;
  return `${M2.format(value)} m²`;
}

export function formatScore(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return EM_DASH;
  return SCORE.format(value);
}

export function pricePerM2(
  kaufpreis: number | null | undefined,
  wohnflaeche: number | null | undefined,
): number | null {
  if (kaufpreis == null || wohnflaeche == null || wohnflaeche <= 0) return null;
  return kaufpreis / wohnflaeche;
}

/**
 * Coarse "vor X Tagen / vor X Stunden" relative time. Falls back to the
 * absolute date for anything older than 14 days so we don't say "vor 3 Monaten"
 * which feels imprecise for triage.
 */
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return EM_DASH;
  const then = Date.parse(iso);
  if (!Number.isFinite(then)) return EM_DASH;
  const diffMs = then - Date.now();
  const diffMin = Math.round(diffMs / 60_000);
  const absMin = Math.abs(diffMin);

  if (absMin < 1) return "gerade eben";
  if (absMin < 60) return RTF.format(diffMin, "minute");
  if (absMin < 60 * 24) return RTF.format(Math.round(diffMin / 60), "hour");
  if (absMin < 60 * 24 * 14)
    return RTF.format(Math.round(diffMin / (60 * 24)), "day");

  return new Date(then).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
